import { array, boolean, number, object, string } from 'yup';
import {
  glTemplateDescriptionRegex,
  glTemplateIdRegex,
  glTemplateNameRegex,
} from '../../../constants/regex';

export const GLTEMPLATE_ID_PREFIX = 'GL - ';

export const tableColumns = [
  'AC SET',
  'ACCOUNT NUMBER',
  'DESCRIPTION',
  'DEBIT',
  'CREDIT',
  '% ALLOCATION',
  '',
];

export const glTemplateValidationSchema = object({
  accountSets: array()
    .of(
      array()
        .of(
          object()
            .shape({
              debit: boolean(),
              credit: boolean(),
              allocationPercentage: number(),
            })
            .test(
              'check-is-debit-credit-selected',
              'Either Credit or Debit needs to be selected',
              (account) => account.credit || account.debit,
            ),
        )
        .test(
          'check-for-accounts-present',
          'At least 2 Accounts are required',
          (set) => set?.length >= 2,
        )
        .test(
          'check-100-percent',
          'Both Credit & Debit should Add up to 100% individually',
          (set) => {
            let debitPercentage = 0;
            let creditPercentage = 0;

            if (set?.length > 0) {
              set.forEach((account) => {
                if (account.credit) creditPercentage += account.allocationPercentage;
                if (account.debit) debitPercentage += account.allocationPercentage;
              });
            }
            if (
              debitPercentage &&
              creditPercentage &&
              debitPercentage === 100 &&
              creditPercentage === 100
            ) {
              return true;
            }
            return false;
          },
        ),
    )
    .nullable()
    .required('At least 1 Account Set is required'),
  gltId: string()
    .trim()
    .required('Id is required')
    .matches(glTemplateIdRegex, `Id must be 100 alphanumeric characters only`),
  gltName: string()
    .trim()
    .required('Name is required')
    .matches(glTemplateNameRegex, `Name must be 2 to 100 characters long and alphabet only`),
  gltType: object().required('Type is required').nullable(),
  gltCategory: object().required('Category is required').nullable(),
  gltDescription: string()
    .trim()
    .required('Description is required')
    .matches(
      glTemplateDescriptionRegex,
      `Description must be 2 to 255 characters long and alphanumeric`,
    ),
});

export const gltSearchSchema = object({
  gltId: object().nullable(),
  gltName: object().nullable(),
  gltType: object().nullable(),
  gltCategory: object().nullable(),
});

export const ACTION_SEARCH = 'search';
export const ACTION_PAGINATION = 'pagination';

export const GLTTableColumns = ['GL IDENTIFICATION', 'GL TEMPLATE NAME', 'GL DESCRIPTION', ''];
